import React from 'react';
import './AboutMeImageSection.css';
import Button from './Button';

class AboutMeImageSection extends React.Component {

  getLiTag(text, index){
    return <li key={index}>{text}</li>
  }

  getH4Tag(text, index){
    return (<span key={index}><h4>{text}</h4><br/></span>)
  }

  render() {
    const {name, location, picture, areasOfExpertise, education, footNotes} = this.props.aboutMeInfoData;
    return (
      <section id='about-me-image-section'>
        <div className='row text-center about-me-title'>
          <h2>{name}</h2>
          <h3>&mdash; {location} Instructor &mdash;</h3>
        </div>
        <div id='about-me-card'>
          <div className='row'>
            <div className='about-me-card-image col span-3-of-3'>
              <div className=' col span-1-of-2'>
                <img src={picture} alt='Erin Walerko'/>
              </div>
              <div className='col span-1-of-2'>
                <div className='about-me about-me-areas-of-expertise'>
                  <h4>Areas of Expertise:</h4>
                  <ul>
                    {areasOfExpertise.map((text, index) => this.getLiTag(text, index))}
                  </ul>
                </div>
                <div className='about-me about-me-education'>
                  <h4>Education:</h4>
                  <ul>
                    {education.map((text, index) => this.getLiTag(text, index))}
                  </ul>
                </div>
                <div className='about-me about-me-button'>
                  <Button buttonText={'Get In Contact'} buttonType={'internalLinkButton'} linkTo={'#get-in-contact'}/>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='about-me-text col span-3-of-3 text-center'>
              {footNotes.map((text,index) => this.getH4Tag(text,index))}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

AboutMeImageSection.propTypes = {
  aboutMeInfoData: React.PropTypes.object.isRequired
}

export default AboutMeImageSection;



// WEBPACK FOOTER //
// ./src/components/AboutMeImageSection.js